import { arrayUnion, doc, onSnapshot, updateDoc, getDoc } from 'firebase/firestore';
import React, { useEffect, useContext, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { auth, db } from '../../firebase';
import Swal from 'sweetalert2'
import Gifts from './Gifts';
import { BsBoxArrowInRight, BsInfoCircle } from 'react-icons/bs';
import { IoRefreshSharp } from 'react-icons/io5';
import { FaPaste } from 'react-icons/fa';
import { MdGroupAdd } from 'react-icons/md'
import emailjs from '@emailjs/browser';
import { searchBarInfo } from './searchbarinfo';
import keyImage from '../../images/icon_key.png'
import { GiHeartKey } from 'react-icons/gi';
import DisplayConfirmation from '../confirm_gift_add/DisplayConfirmation';







export default () => {
    // const currentUser = useContext(AuthContext) // development
    // const user = currentUser.currentUser // development
    const user = auth.currentUser // production version
    const location = useLocation();
    const eventId = location.pathname.split("/")[3]

    const [giftName, setGiftName] = useState('');
    const [giftLink, setGiftLink] = useState('');
    const [giftCost, setGiftCost] = useState('');
    const [giftInfo, setGiftInfo] = useState('');
    const [remObject, setRemObject] = useState('');
    const [userData, setUserData] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [giftArray, setGiftArray] = useState([]);
    const [eventData, setEventData] = useState({});
    const [isClaimed, setIsClaimed] = useState(false);
    const [didSubmit, setDidSubmit] = useState(false);
    const [requestor, setRequestor] = useState(user.email);
    const [eventParticipants, setEventParticipants] = useState([user.email]);
    const [chosen, setChosen] = useState(1000)
    const [giftRef] = useState(eventId);
    const [inFocus, setInFocus] = useState(false);
    const [hideMyItems, setHideMyItems] = useState(false);
    const [hideClaimedItems, setHideClaimedItems] = useState(false);
    const [displayConfState, setDisplayConfState] = useState({ display: false, success: false });





    const eventRef = doc(db, 'events', eventId) // add gifts to this event

useEffect(() => {
    let list = [];
    // console.log(eventId);

    const getUserEvents = async () => {
        try {
            const docRef = doc(db, 'events', eventId)
            const docSnap = await getDoc(docRef)
            if (docSnap.exists()) {
                setEventData(docSnap.data().events)

                list.push(docSnap.data().eventParticipants)
            } else {
                console.log('must have been no data...');
            }

        } catch (error) {
            console.log(error);
        }
    }
    getUserEvents()
    const userRef = doc(db, 'users', user.uid)
    const getUserInfo = async () => {
        const userInfo = await getDoc(userRef)
        if (userInfo.exists) {
            setUserData({
                username: userInfo.data().username || '',
                img: userInfo.data().img || '',
                userEmail: userInfo.data().email
            })
            if (userInfo.data().username !== user) {
                // console.log(user)
                // console.log(userInfo.data().username)
            }
        } else {
            console.log('no data');
        }
    }
    getUserInfo()

    const updateUserNameGifts = async (updatedUsernameArray) => {
        // console.log(updatedUsernameArray);
        try {
            await updateDoc(eventRef, {
                gifts:
                    [...updatedUsernameArray]
            })
        } catch(e) {
            console.log(e);
        }
    }
    const getGifts = async () => {
        let userNameChanged = false;
        const giftRef = doc(db, 'events', eventId);
        try {
            const docSnap = await getDoc(giftRef)
            const myGiftsToUpdate = docSnap?.data()?.gifts?.filter((me => {
                return me.requestor === user.email;
            }));
            const remainingGifts = docSnap?.data()?.gifts?.filter((me => {
                return me.requestor !== user.email;
            }));

            const updatedUsernameArr = myGiftsToUpdate?.map((gift) => {

                if (user && userData !== undefined && gift.username === userData.username) {

                    return
                } else {
                    userNameChanged = true
                    gift.username = user.displayName || userData.username

                        return {
                            ...gift
                        }
                }
            });

            const mergedArr = remainingGifts && updatedUsernameArr ? [...remainingGifts, ...updatedUsernameArr] : []

            if (userNameChanged && !updatedUsernameArr.includes(undefined)) {
                updateUserNameGifts(mergedArr)
            }
        } catch (error) {
            console.error(error);
        }
    }
    getGifts()


    const unsub2 = onSnapshot(doc(db, "events", eventId), doc => {
        // console.log('current doc data ', doc.data());
        const arr = [];
        const list = [];

        arr.push({id: doc.id, ...doc.data().gifts})
        list.push({id: doc.id, ...doc.data().eventParticipants})



        let format = Object.values(arr[0])
        let format2 = Object.values(list[0])

        setGiftArray(format.slice(0, -1))
        setEventParticipants(format2.slice(0, -1))
    })


    return () => {
        unsub2()
    }

    // const queryInvites = query(collection(db, "invites"), where("invitee", "==", userEmail))

}, [didSubmit])

// console.log(eventParticipants);
// console.log(giftArray);



    const handleSubmit = async e => {
        let defaultCost = 0

        e?.preventDefault();
        if (giftName === '') return Swal.fire({ title: 'Must enter a gift name!', confirmButtonColor: `` });
        try {
            // setDoc(doc(db, 'cities')) is when you provide your own ID item (3rd arg)
            // if (userName === '') ?? wtf is this ; don't game and debug
            await updateDoc(eventRef, {
                gifts: arrayUnion(
                    {
                        giftName: giftName,
                        giftLink: giftLink,
                        giftInfo: giftInfo,
                        claimed: isClaimed,
                        requestor: requestor,
                        giftRef: giftRef,
                        username: userData.username,
                        img: userData.img,
                        giftCost: giftCost !== '' ? giftCost : defaultCost
                    }
                )
            })

            setDisplayConfState(() => ({ success: true, displayError: false }));
        } catch (error) {
            console.error(error);
            setDisplayConfState(prev => ({ ...prev, displayError: true }));
        }
        setDidSubmit(current => !current);
        setGiftName('');
        setGiftLink('');
        setGiftCost('');
        setGiftInfo('');
    }

    const sweetModal = async () => {
        const { value: email } = await Swal.fire({
            title: 'Enter new participant email',
            input: 'email',
            inputLabel: 'Email',
            confirmButtonColor: '',
            showCancelButton: true,
            cancelButtonColor: '',
            inputPlaceholder: 'Enter email address here',
            title: eventParticipants && `Event participants: \n${eventParticipants.join(' ')}`,

        })
        if (email) {
            // console.log('event participants ' , eventParticipants, email)
            // updatePartici()
            // console.log(eventParticipants)
            Swal.fire({
                title: `User(s) ${email} added to participants!`,
                confirmButtonColor: '',
                // text: `Save user email to friends list?`,
                // showDenyButton: true
            })
            .then(() => setEventParticipants(prev => [...prev, email]))
            // .then(() => updateDoc(eventRef, {
            //     eventParticipants: arrayUnion(...eventParticipants)
            // }))
            // .then(() => setDidSubmit(prev => !prev))
            .catch(err => console.log(err))
            // .then((result) => result.isConfirmed ? setEventParticipants(eventParticipants => [...eventParticipants, email]) : null)
            // friends list add on
        }
       // updatePartici()
    }
    const updatePartici = async () => {
        try {
            await updateDoc(eventRef, {
                eventParticipants: arrayUnion(...eventParticipants)
            })
            } catch (error) {
                console.log(error)
            }
    }
    updatePartici()

    const search = (data, choice) => {
        let keys = ['giftName', 'requestor', 'username']

        if(choice === 1000) { // all
            return data.filter(i => keys.some((key) => i[key]?.toLowerCase().includes(searchQuery.toLowerCase())))
        } else if (choice === 201) {
            return data.filter((i => i?.giftCost >= choice && keys.some((key) => i[key]?.toLowerCase().includes(searchQuery.toLowerCase()))))
        } else if (choice === '50u') {
            return data.filter((i => i?.giftCost <= 50 && keys.some((key) => i[key]?.toLowerCase().includes(searchQuery.toLowerCase()))))
        } else if (choice === '50o') {
            return data.filter((i => i?.giftCost >= 50 && keys.some((key) => i[key]?.toLowerCase().includes(searchQuery.toLowerCase()))))
        } else  if (choice === 'yourClaims') {
            return data.filter((i) => i?.claimee === user.email && keys.some((key) => i[key]?.toLowerCase().includes(searchQuery.toLowerCase())))
        } else  if (choice === 'yourSplits') {
            return data.filter((i) => i?.splittees !== undefined && i.splittees !== '' && i.splittees.includes(user.email) && keys.some((key) => i[key]?.toLowerCase().includes(searchQuery.toLowerCase())))
        } else if (choice) {
            return data.filter((i => i?.giftCost >= choice - 25 && i?.giftCost <= choice && keys.some((key) => i[key]?.toLowerCase().includes(searchQuery.toLowerCase()))))
        // } else  if (!choice) {
        //     console.log('!choice fired');
        //     return data.filter((item) =>
        //     keys.some((key) => item[key]?.toLowerCase().includes(searchQuery.toLowerCase())))
        }
    }
// i believe we are going to need to combine these twon functions
// later that day... I believe you are correct
    // const dollarAmount = (data, choice) => {
    //     if(choice === 1000) {
    //         return data.filter(i => i.giftCost <= choice)
    //     }
    //     if (choice) { // all
    //         return data.filter((i => i.giftCost >= choice - 25 && i.giftCost <= choice))
    //     }
    // }
    const handleSelect = e => {
        e.preventDefault();

        if (!e.target.value) {
            return

        } else {
            switch
            (e.target.value) {
                case '25':
                    setChosen(25)
                    break;
                case '50':
                    setChosen(50)
                    break;
                case '75':
                    setChosen(75)
                    break;
                case '100':
                    setChosen(100)
                    break;
                case '125':
                    setChosen(125)
                    break;
                case '150':
                    setChosen(150)
                    break;
                case '175':
                    setChosen(175)
                    break;
                case '200':
                    setChosen(200)
                    break;
                case '201':
                    setChosen(201)
                    break;
                case '1000':
                    setChosen(1000)
                    break;
                case 'yourClaims':
                    setChosen('yourClaims')
                    break;
                case 'yourSplits':
                    setChosen('yourSplits')
                    break;
                default:
                    setChosen(100000)
                }
        }

    }

    const onTheList = eventParticipants.includes(user.email)

    const updateGiftArray = async (remGiftName) => {
        try {
            await updateDoc(eventRef, {
                gifts: (
                        giftArray.filter(i => i !== remGiftName)
                )
            })
            // console.log(eventRef)
            } catch (error) {
                console.log(error)
            }
    }

    const handleRemove = async () => {
        const yourItems = giftArray.filter(i => user.email === i.requestor)
        const items = yourItems.map(i => i.giftName)

        const { value: item } = await Swal.fire({
            title: `Please select gift to remove!`,
            confirmButtonColor: '',
            input: 'select',
            inputOptions: {
                'Item to remove':
                {...items}
            },
            inputPlaceholder: `Your choices...`
        })
        if (item) {
            const gift = yourItems[item].giftName
            const eventId = yourItems[item].giftRef
            const giftIsClaimed = yourItems[item].claimed

            const remGiftName = yourItems[item]
            setRemObject(remGiftName)
            let mes = 'Send the claimee an automated email regarding the removal of the gift they formerly claimed?'

            let warningMessage;
            switch
                (giftIsClaimed) {
                    case true:
                        warningMessage = `Wait! Someone has claimed this gift, item: "${gift}" may have already been purchased! Are you sure you want to delete this? (Note: This is irreversible!)`
                        break;
                    default:
                        warningMessage = `Are you sure you want to remove Gift: "${gift}"? (Note: This is irreversible!)`
                }
            await Swal.fire({
                title: `${warningMessage}`,
                icon: 'warning',
                iconColor: '',
                showCancelButton: 'true',
                confirmButtonColor: ''
            })
            .then(async (result) => {
                if (result.isConfirmed) {
                    updateGiftArray(remGiftName)
                    const { value: email } = await Swal.fire({
                        title: `Gift: "${gift}" removed!`,
                        confirmButtonColor: '',
                        confirmButtonText: 'Got it!',
                        input: giftIsClaimed ? 'checkbox' : '',
                        inputValue: 1,
                        html: giftIsClaimed ? `${mes}` : ``,
                    })
                    if (email && giftIsClaimed) {
                        let tex = ''
                        const { value: text } = await Swal.fire({
                            title: 'Notes to user in automated email...',
                            input: 'textarea',
                            inputPlaceholder: 'E.G. Someone else already bought this item for my cat/dog',
                            showCancelButton: true,
                            cancelButtonText: 'Skip',
                            confirmButtonColor: '',
                            confirmButtonText: 'Send'
                        })
                        if (text) {
                            tex = text
                        }


                        let claimeeEmail = remGiftName?.claimee
                        let eName = eventData.eventName
                        let eDate = eventData.eventDate
                        let userE = remGiftName.requestor

                        let tempParam = {
                            from_name: remGiftName.requestor,
                            event_name: eName,
                            event_date: eDate,
                            to_email: claimeeEmail,
                            from_email: userE,
                            gift_name: gift,
                            message: tex
                        }
                        const templateID = 'template_l4kp685';
                        const publicKey = 'C0U6FhGhn-2kWm9SD';
                        const handleEmail = async () => {
                            await emailjs.send('default_service', templateID, tempParam, publicKey)
                                .then((res) => console.log('Success ', res.status, res.text))
                                .catch(err => console.log(err))
                        }
                        Swal.fire({
                            title: 'Email sent!',
                            html: `With your message: "${tex}"`,
                            confirmButtonColor: ''
                        })
                        .then(() => handleEmail())
                    }
                } else {
                    Swal.fire({
                        title: 'Gift <b style="font-style: italic;">not</b> deleted!',
                        confirmButtonColor: 'green'
                    })
                }
            })
            .catch(err => console.log(err))

        }

        setDidSubmit(current => !current)

    }

    const pasteLink = async (e) => {
        if (e) {
            await navigator.clipboard.readText()
                .then(text => setGiftLink(text))
        }
    }
    const itemKey = () => {
        Swal.fire({
            imageUrl: keyImage,
        })
    }

    return (
        <>


        <div className='flex items-center justify-center flex-col'>
        {onTheList || user.email === eventData.eventOwner ? (<>
            <div className='flex flex-col'>
                {eventData && <h2 className='text-2xl sm:text-4xl my-2 text-center'>Event: "{eventData.eventName}"</h2>}
                <div id="eventBreakDown" className='flex flex-row my-2 items-center justify-center'>
                    Your event summary
                    <Link className='text-black no-underline mr-2' to={`/dashboard/eventinfo/${eventId}`}>
                        <BsBoxArrowInRight className='ml-2 text-primary hover:text-secondary hover:scale-[115%] hover:duration-200 hover:ease-in-out' size={'30px'} />
                    </Link>
                </div>
                <div className='flex flex-row items-center justify-center'>
                    <p className='mr-2 my-2' id="addeventparti">Add event participants</p>
                    <a className='ml-2 text-secondary hover:cursor-pointer' onClick={sweetModal}><MdGroupAdd id="addPartIcon" className='hover:text-accent hover:scale-[115%] hover:duration-200 hover:ease-in-out' size={'36px'} /></a>
                </div>
                <div className='flex flex-row items-center justify-center'>
                    <a className='text-base text-inherit no-underline mr-2' onClick={itemKey}>View Icon Legend</a>
                    <a onClick={itemKey} ><GiHeartKey className="text-info hover:cursor-pointer hover:text-secondary hover:scale-[115%] hover:duration-200 hover:ease-in-out" size={'36px'} /></a>
                </div>
            </div>
            <hr />
            <h3 className='text-center my-2 text-xl sm:text-3xl'>Add to gift list...</h3>
            <div className='formContainer w-full'>

                    <form className='w-full mx-auto flex items-center justify-center flex-col' onSubmit={handleSubmit}>
                        <input className='input input-bordered focus:input-primary my-2 w-[300px] sm:w-[600px] italic' value={giftName} name="giftname" placeholder='Gift Name' onChange={e => setGiftName(e.target.value)} />

                        <div className='flex flex-row my-2 w-full mx-auto items-center justify-center' id="iconDiv">
                            <div className='grid grid-cols-1 grid-rows-1 w-full items-center justify-center'>
                                <input className='input input-bordered focus:input-primary w-[300px] sm:w-[600px] col-start-1 row-start-1 mx-auto z-40 italic' value={giftLink} name="giftlink" placeholder='Gift Link' onChange={e => setGiftLink(e.target.value)} />
                                <span className='flex items-center justify-center col-start-1 row-start-1 ml-[250px] sm:ml-[550px]' id='bgW'>
                                    <a className='z-50' id="iconEl" onClick={e => pasteLink(e)}><FaPaste className='right-32 text-accent hover:scale-[115%] hover:duration-200 hover:ease-in-out' size={'30px'} id="pasteicon" /></a>
                                </span>
                            </div>
                        </div>

                        <input className='input input-bordered focus:input-primary my-2 w-[300px] sm:w-[600px] italic' type='number' value={giftCost} name="giftcost" placeholder='Gift Cost' onChange={e => setGiftCost(e.target.value)} />
                        <textarea className='textarea textarea-bordered focus:textarea-primary w-[300px] sm:w-[600px] italic my-2' value={giftInfo} onChange={e => setGiftInfo(e.target.value)} name="giftinfo" placeholder='Items details, e.g. color, size, surprise'>

                        </textarea>

                        <div>
                            <DisplayConfirmation
                                text={"Item"}
                                displayConfState={displayConfState}
                                setDisplayConfState={setDisplayConfState}
                            />
                            <button className='btn btn-secondary my-2 mr-1 hover:bg-primary' type="submit" >Add Gift</button>
                            <button className='btn btn-warning my-2 ml-1 hover:bg-error' type="button" name='removeBtn' onClick={handleRemove}>Remove Gift</button>
                        </div>
                    </form>
            </div>
            <div className={giftArray.length === 0 ? 'hidden searchContainer' : 'searchContainer'}>
                <span className='flex items-center justify-center sm:flex-row flex-col' id="filterSpan">
                    <a onClick={searchBarInfo}><BsInfoCircle className='mt-2 text-info' size={'25px'} /></a><input className='input input-bordered my-4 sm:mx-2 italic' type="text" onFocus={() => setInFocus(true)} onBlur={() => setInFocus(false)} value={searchQuery} placeholder='Filter Results' onChange={e => setSearchQuery(e.target.value)} />
                    <div className='sm:mx-2'>

                        <button id="refreshBtn" onClick={() => setSearchQuery('')} className="btnInvert"><IoRefreshSharp size={'30px'} /></button>
                    </div>
                    <select id="selectValue" className='select border border-base-300 my-4 sm:mx-2' name="cost" onFocus={() => setInFocus(true)} onBlur={() => setInFocus(false)} onChange={e =>handleSelect(e)}>
                        <optgroup label="Filter Choices">
                            <option value="1000">All Items</option>
                            <option value="25">Up to 25$</option>
                            <option value="50">25 to 50$</option>
                            <option value="75">50 to 75$</option>
                            <option value="100">75 to 100$</option>
                            <option value="125">100 to 125$</option>
                            <option value="150">125 to 150$</option>
                            <option value="175">150 to 175$</option>
                            <option value="200">175 to 200$</option>
                            <option value="201">200$ and up</option>
                            <option value="yourClaims">Your claims</option>
                            <option value="yourSplits">Your splits</option>
                        </optgroup>
                    </select>
                </span>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center'}}>
                    <span style={{fontSize: '14px'}} id="hideMyItems">Hide my items and all claimed items&nbsp;<input className='checkbox' type='checkbox' value={hideMyItems} onChange={() => setHideMyItems(prev => !prev)} defaultChecked={false} />
                    </span>
                </div>

            </div>
            <Gifts
                giftArray={giftArray && search(hideMyItems
                    ? giftArray.filter(i => i.requestor !== user?.email && i.claimed !== true)
                    : giftArray, chosen)}
                originalGiftArray={giftArray}
                user={user}
                inFocus={inFocus}
            />
        </>) : (
            <div style={{textAlign: 'center'}}>
                <h1>You must be added to the event list to participate!</h1>
            </div>
        )}
        </div>
        </>
    )
}